export default {
  methods: {
    adjustScroll(scrollBefore, heightBefore) {
      const scrollEl = document.getElementById('content__wrapper');
      const listEl = document.getElementById('listView');
      const diff = listEl.offsetHeight - heightBefore;
      if (Number.isFinite(diff) && diff !== 0) {
        scrollEl.scrollTop = Math.max(0, scrollBefore + diff);
      }
    },
    scrollList(prop) {
      if (prop.endPage && !this.isLoading && this.isLastDownloaded) {
        this.curPage += 1;
        this.getPage();
      }
      if (prop.startPage && !this.isLoading && this.firstPage > 1) {
        this.getPrevPage();
      }
    },
    checkScrollBoundaries() {
      const el = document.getElementById('content__wrapper');
      if (el.scrollTop === 0 && this.firstPage > 1 && !this.isLoading) {
        this.getPrevPage();
      }
    },
    repeatGetPage() {
      this.getPage();
    },
  },
};
